import { MealRatioArray } from './../../../core/model/object/diet-model';
import { MainShared } from 'src/app/presentation/general/shared/main-shared';
import { CalendarShared } from './../../../presentation/general/shared/calendar-shared';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { mainUrl } from 'src/app/global-variables';
import {
  DietDayFoodLogsModel,
  FoodLogModel,
} from './../../../core/model/object/foodlog-model';
import { FoodLogDataService } from './food-log-data.service';
import { FoodDataService } from './food-data.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { AddFoodLogInputModel } from './../../../core/model/input/food-log-input-model';
import { FoodLogService } from './food-log.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { generateTypeUrl } from './../../../global-variables';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { DietApiService } from './diet-api.service';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { DietDataService } from './diet-data.service';
import {
  DietModel,
  DietDayModel,
  DietSearchMealModel,
  DietFoodModel,
  DietMealModel,
} from 'src/app/core/model/object/diet-model';
import {
  FoodFacts,
  FoodFactsModel,
  FoodFactModel,
  FoodModel,
} from 'src/app/core/model/object/diet-food-model';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { DiaryAnalyticsService } from '../analytics-repository/diary-analytics.service';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';
import { Subject } from 'rxjs';
import { WebengageService } from '../analytics-repository/webengage.service';

@Injectable({
  providedIn: 'root',
})
export class PlanService {
  constructor(
    private router: Router,
    private location: Location,
    private dietApiService: DietApiService,
    private dietDataService: DietDataService,
    private planShared: PlanShared,
    private diaryAnalytics: DiaryAnalyticsService,
    private routeAnimationShared: RouteAnimationShared,
    private dateHelper: DateHelper,
    private foodLogService: FoodLogService,
    private userDataService: UserDataService,
    private foodDataService: FoodDataService,
    private foodLogDataService: FoodLogDataService,
    private weightLogService: WeightLogService,
    private calendarShared: CalendarShared,
    private mainShared: MainShared,
    private calorieCalculator: CalorieCalculator,
    private webengage: WebengageService
  ) {}
  closeBottomSheet: Subject<boolean> = new Subject();
  openTable: Subject<boolean> = new Subject();

  goToCheatDay(
    dietId: string,
    day: string,
    isCheat: boolean,
    cheatDayCount,
    isPredefined: boolean
  ) {
    const cheatString = isCheat ? '1' : '0';
    const isPredefinedString = isPredefined ? '1' : '0';
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([
      '/cheatday/' +
        dietId +
        '/' +
        (parseInt(day) - 1) +
        '/' +
        cheatString +
        '/' +
        cheatDayCount +
        '/' +
        isPredefinedString,
    ]);
  }

  goBack() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
  }

  goToMain() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([mainUrl]);
  }

  goToMealDetail(
    dietId: string,
    day: string,
    isPredefined: boolean,
    cheatDayCount: number
  ) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([
      '/mealdetail/' +
        dietId +
        '/' +
        day +
        '/' +
        (isPredefined ? '1' : '0') +
        '/' +
        cheatDayCount.toString(),
    ]);
  }
  goToExercise() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/exercise']);
  }
  goToNewExercise() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/exercise/new']);
  }
  goToDailyFoodFact() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/dailyfoodfact']);
  }

  goToChangeMeal(dietId: string, day: string, meal: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/changemeal/' + dietId + '/' + day + '/' + meal]);
  }

  goToAddFood(dietId: string, day: string, meal: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/addfood/' + dietId + '/' + day + '/' + meal]);
  }
  goToPersoanlpackage(dietId: string, day: string, meal: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['persoanl/main/' + dietId + '/' + day + '/' + meal]);
  }
  goToPersoanlFoodMain(dietId: string, day: string, meal: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([
      'persoanl/food/main/' + dietId + '/' + day + '/' + meal,
    ]);
  }
  goToPersoanlFoodAdd(edit: boolean) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['persoanl/food/add/' + edit]);
  }
  goToPersoanlPackageAdd(edit: boolean) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['persoanl/package/add/' + edit]);
  }
  goToPersonalPackageMain(dietId: string, day: string, meal: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([
      'persoanl/package/main/' + dietId + '/' + day + '/' + meal,
    ]);
  }
  goToGenerate() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([generateTypeUrl]);
  }

  goToPlanOverview() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/planoverview']);
  }

  goToSecondTabPlans() {
    this.mainShared.secondTabPlans();
  }

  goToSecondTabMyPlan() {
    this.mainShared.secondTabMyPlan();
  }

  changeFastingStartTime(
    startTime: number,
    dietId: string
  ): Promise<GenericResponse> {
    return this.dietApiService
      .changeFastingStartTime(startTime, dietId)
      .then((result) => {
        if (result.isSuccess()) {
          const fastingTime = startTime;
          return this.dietDataService.getDiets().then(async (res) => {
            if (res.diets.length !== 0) {
              res.diets.forEach((diet) => {
                if (diet._id === dietId) {
                  diet.fasting.fastingTime = fastingTime;
                }
              });
              await this.dietDataService.saveDiets(res.diets);
            }
            return result;
          });
        } else {
          return result;
        }
      });
  }

  getDietRatioArray(): Promise<MealRatioArray[]> {
    return this.dietDataService.getDiets().then(async (res) => {
      if (res.diets && res.diets.length !== 0) {
        return res.diets[0].type.mealRatioArray;
      } else {
        return [];
      }
    });
  }
  getDiet() {
    let response: GenericResponse;
    return this.dietDataService.getDiets().then(async (res) => {
      if (res.diets && res.diets.length !== 0) {
        res.diets = await this.prepareDietsFoods(res.diets);
        response = new GenericResponse(
          true,
          new GenericResponseData({ type: 'hasDiet', diets: res.diets })
        );
      } else {
        response = new GenericResponse(false);
      }
      return response;
    });
  }
  getDiets() {
    let response: GenericResponse;
    return this.dietDataService.getDiets().then(async (res) => {
      if (res.diets && res.diets.length !== 0) {
        res.diets = await this.prepareDietsFoods(res.diets);
        response = new GenericResponse(
          true,
          new GenericResponseData({ type: 'hasDiet', diets: res.diets })
        );
      } else {
        response = new GenericResponse(false);
      }

      return response;
    });
  }
  getDayDiet() {
    let response: GenericResponse;
    return this.dietDataService.getDiets().then(async (res) => {
      if (res.diets && res.diets.length !== 0) {
        let date = new Date(new Date().setHours(0, 0, 1, 0)).getTime();
        let dd =
          this.dateHelper.calculateDays(res.diets[0].startDate, date) + 1;
        let dietIndex = res.diets[0].days.findIndex(
          (v) => v.day == dd.toString()
        );
        let s = await this.prepareDayDietsFoods(res.diets[0].days[dietIndex]);
        res.diets[0].days[dietIndex] = s;
        response = new GenericResponse(
          true,
          new GenericResponseData({
            type: 'hasDiet',
            diets: res.diets,
            days: dd,
          })
        );
      } else {
        response = new GenericResponse(false);
      }
      return response;
    });
  }
  getDaysDiet() {
    let response: GenericResponse;
    return this.dietDataService.getDiets().then(async (res) => {
      if (res.diets && res.diets.length !== 0) {
        response = new GenericResponse(
          true,
          new GenericResponseData({ type: 'hasDiet', diets: res.diets })
        );
      } else {
        response = new GenericResponse(false);
      }

      return response;
    });
  }
  async getDietList(): Promise<GenericResponse> {
    let response: GenericResponse;
    const dietsGenericResponse = await this.dietApiService.getDiets();
    if (dietsGenericResponse.isSuccess()) {
      if (dietsGenericResponse.getData().getType() === 'getFoods') {
        const foodsGenericResponse = await this.dietApiService.getDietsFoods();
        return foodsGenericResponse;
      } else {
        this.dietDataService.updateUpdatedAt();
        response = new GenericResponse(true);
        return response;
      }
    } else {
      response = new GenericResponse(false);
      return response;
    }
  }

  async getDietListAndRefreshDB(): Promise<GenericResponse> {
    let response: GenericResponse;
    return await this.dietApiService.getDietsAndRefreshDB().then((res) => {
      if (res.isSuccess()) {
        if (res.getData().getType() === 'getFoods') {
          return this.dietApiService.getDietsFoods().then(async (result) => {
            if (result.isSuccess()) {
              return this.dietDataService.getDiets().then(async (resp) => {
                await this.dietDataService.deleteAndSaveDiets(resp.diets);
                response = new GenericResponse(true);
                return response;
              });
            } else {
              response = new GenericResponse(false);
              return response;
            }
          });
        } else {
          response = new GenericResponse(true);
          return response;
        }
      } else {
        response = new GenericResponse(false);
        return response;
      }
    });
  }

  getFoodDetail(foodIds: string[], save: boolean = false) {
    return this.dietApiService.getFoods(foodIds, save);
  }
  async getFoodDeatailByDb(foodId: string): Promise<FoodModel> {
    let data: FoodModel;
    await this.foodDataService.getFood(foodId).then((f) => {
      data = f;
    });
    if (!data) {
      await this.getFoodDetail([foodId], true);
      await this.foodDataService.getFood(foodId).then((f) => {
        data = f;
      });
    }
    return Promise.resolve(data);
  }

  async addFood(
    foodlogInputModel: AddFoodLogInputModel[],
    saveToPlanShared: boolean
  ): Promise<GenericResponse> {
    const user = await this.userDataService.getUser();
    foodlogInputModel.forEach((foodlog, i) => {
      foodlogInputModel[i].user = user._id;
    });
    const res = await this.foodLogService.addFoodLog(foodlogInputModel);
    if (res.isSuccess()) {
      const date = res.getData().getFoodLogs()[0].date;
      const response = await this.foodLogDataService.updateFoodLogs(
        res.getData().getFoodLogs(),
        date
      );
      if (saveToPlanShared) {
        let dietDayFoodLogs = await this.foodLogDataService.getDayFoodLogs(
          date
        );
        dietDayFoodLogs = await this.prepareDietDayFoodLogs(dietDayFoodLogs);
        this.planShared.selectedDietDayFoodLogs = dietDayFoodLogs;
      }
    }
    return res;
  }

  async editFood(
    unit: string,
    amount: number,
    foodLog: FoodLogModel,
    calorie?: number
  ): Promise<GenericResponse> {
    const res = await this.foodLogService.updateFoodLog(
      foodLog._id,
      amount,
      unit,
      calorie
    );
    if (res.isSuccess()) {
      const fl = new FoodLogModel(
        amount,
        foodLog.date,
        foodLog.food,
        foodLog.meal,
        unit,
        foodLog.user,
        null,
        foodLog._id,
        calorie,
        foodLog.title
      );
      // console.log({ fl });

      const response = await this.foodLogDataService.updateFoodLogs(
        [fl],
        foodLog.date
      );
      let dietDayFoodLogs = await this.foodLogDataService.getDayFoodLogs(
        foodLog.date
      );

      dietDayFoodLogs = await this.prepareDietDayFoodLogs(dietDayFoodLogs);
      this.planShared.selectedDietDayFoodLogs = dietDayFoodLogs;
    }
    return res;
  }

  async removeFood(
    date: number,
    foodLogIds: string[],
    saveToPlanShared: boolean
  ): Promise<GenericResponse> {
    const res = await this.foodLogService.deleteFoodLog(foodLogIds);
    if (res.isSuccess()) {
      const response = await this.foodLogDataService.removeFoodLogs(
        date,
        foodLogIds
      );
      if (saveToPlanShared) {
        let dietDayFoodLogs = await this.foodLogDataService.getDayFoodLogs(
          date
        );
        dietDayFoodLogs = await this.prepareDietDayFoodLogs(dietDayFoodLogs);
        this.planShared.selectedDietDayFoodLogs = dietDayFoodLogs;
      }
    }
    return res;
  }

  async getThisDayFoodLogsServer(
    date: number,
    saveToPlanShared: boolean,
    updatedAt: number
  ): Promise<FoodLogModel[]> {
    const answer = await this.foodLogService.getFoodLog(date, updatedAt);
    let dietDayFoodLogs = await this.foodLogDataService.getDayFoodLogs(date);
    dietDayFoodLogs = await this.prepareDietDayFoodLogs(dietDayFoodLogs);
    if (saveToPlanShared) {
      this.planShared.selectedDietDayFoodLogs = dietDayFoodLogs;
    }
    return Promise.resolve(dietDayFoodLogs.foodLogs);
  }

  async getThisDayFoodLogs(
    date: number,
    saveToPlanShared: boolean,
    updateFoodLogs: boolean
  ): Promise<FoodLogModel[]> {
    let dietDayFoodLogs = await this.foodLogDataService.getDayFoodLogs(date);
    if (dietDayFoodLogs) {
      dietDayFoodLogs = await this.prepareDietDayFoodLogs(dietDayFoodLogs);
      if (saveToPlanShared) {
        this.planShared.selectedDietDayFoodLogs = dietDayFoodLogs;
      }
      if (updateFoodLogs) {
        this.foodLogService
          .getFoodLog(date, dietDayFoodLogs.updatedAt)
          .then((res) => {
            if (res.getData().getType() === 'updated') {
              this.foodLogDataService.getDayFoodLogs(date).then((result) => {
                this.prepareDietDayFoodLogs(result).then((result2) => {
                  if (
                    this.calendarShared.selectedDate &&
                    date === this.calendarShared.selectedDate.getTime()
                  ) {
                    this.planShared.selectedDietDayFoodLogs = result2;
                    this.planShared.refreshDietDay();
                  }
                });
              });
            }
          });
      }
      return Promise.resolve(dietDayFoodLogs.foodLogs);
    } else {
      const ans = await this.getThisDayFoodLogsServer(
        date,
        saveToPlanShared,
        0
      );
      return Promise.resolve(ans);
    }
  }

  async checkThisDayPlan(
    date: Date,
    checkFoodLogs: boolean,
    updateFoodLogs: boolean
  ): Promise<GenericResponse> {
    if (checkFoodLogs) {
      await this.getThisDayFoodLogs(date.getTime(), true, updateFoodLogs);
    }
    let response: GenericResponse;
    let found = false;
    let refresh = false;
    let today = new Date();
    today = new Date(today.setHours(0, 0, 0, 0));
    return this.dietDataService.getDiets().then(async (res) => {
      if (res.diets && res.diets.length !== 0) {
        for (let diet of res.diets) {
          const created = new Date(diet.createdAt).setHours(0, 0, 0, 0);
          const endDate = new Date(diet.endDate).setHours(23, 59, 59, 0);
          diet.startDate = new Date(diet.startDate).setHours(0, 0, 0, 0);
          console.log({
            start: diet.startDate,
            today: date.getTime(),
          });

          if (
            diet.startDate < date.getTime() ||
            (endDate > date.getTime() &&
              date.getTime() < diet.startDate &&
              today.getTime() >= diet.startDate) ||
            today.getTime() == diet.startDate
          ) {
            // diet
            found = true;
            let cheatDayCount = 0;
            const dietDay = await this.dietDay(
              diet,
              this.dateHelper.calculateDays(diet.startDate, date.getTime())
            );
            const TodaydietDay = await this.dietDay(
              diet,
              this.dateHelper.calculateDays(diet.startDate, today.getTime())
            );
            let isCheatDay = false;
            diet.days.forEach((day) => {
              if (day.isCheatDay) {
                cheatDayCount++;

                if (day.day === dietDay.day) {
                  isCheatDay = true;
                }
              }
            });
            if (isCheatDay && date.getTime() > diet.startDate) {
              if (checkFoodLogs) {
                let mealNames = [];
                diet.type.mealRatioArray[0].mealRatios.forEach((mealRatio) => {
                  mealNames.push(mealRatio.meal);
                });
                this.planShared.selectedDietDayFoodLogs.foodLogs =
                  this.planShared.selectedDietDayFoodLogs.foodLogs.filter(
                    (foodLog) => mealNames.includes(foodLog.meal)
                  );
              }
              response = new GenericResponse(
                true,
                new GenericResponseData({
                  type: 'cheatDay',
                  dietCalorie: diet.calorie,
                  dietDay,
                  fasting: diet.fasting,
                  days: cheatDayCount,
                  dietId: diet._id,
                  dietType: diet.type,
                })
              );
            } else {
              if (checkFoodLogs) {
                let mealNames = [];
                diet.type.mealRatioArray[0].mealRatios.forEach((mealRatio) => {
                  mealNames.push(mealRatio.meal);
                });
                this.planShared.selectedDietDayFoodLogs.foodLogs =
                  this.planShared.selectedDietDayFoodLogs.foodLogs.filter(
                    (foodLog) => mealNames.includes(foodLog.meal)
                  );
              }
              console.log(diet.days.length, parseInt(TodaydietDay.day) + 1);

              response = new GenericResponse(
                true,
                new GenericResponseData({
                  type: 'diet',
                  dietRemainingDays:
                    diet.days.length - parseInt(TodaydietDay.day) + 1,
                  dietDay,
                  days:
                    diet.type.isPersonal || diet.type.fasting
                      ? cheatDayCount
                      : 2,
                  fasting: diet.fasting,
                  dietId: diet._id,
                  dietCalorie: diet.calorie,
                  dietType: diet.type,
                  message: new Date(endDate).toISOString(),
                })
              );
            }
          } else if (created < date.getTime() && endDate > date.getTime()) {
            found = true;
            if (date.getTime() >= today.getTime()) {
              response = new GenericResponse(
                true,
                new GenericResponseData({
                  type: 'before',
                  dietId: diet._id,
                  days:
                    this.dateHelper.calculateDays(
                      diet.startDate,
                      new Date().getTime()
                    ) + 1,
                  dietType: diet.type,
                })
              );
            } else {
              response = new GenericResponse(
                true,
                new GenericResponseData({ type: 'noDiet' })
              );
            }
          } else if (
            date.getTime() >= endDate &&
            !diet.isCanceled &&
            today.getTime() < endDate
          ) {
            found = true;
            if (date.getTime() >= today.getTime()) {
              response = new GenericResponse(
                true,
                new GenericResponseData({
                  type: 'hasDiet',
                  message: new Date(endDate).toISOString(),
                })
              );
            } else {
              response = new GenericResponse(
                true,
                new GenericResponseData({ type: 'noDiet' })
              );
            }
          }
        }
        if (refresh) {
          return new GenericResponse(
            false,
            new GenericResponseData({ type: 'refresh' })
          );
        }
        if (!found) {
          if (date.getTime() >= today.getTime()) {
            response = new GenericResponse(
              true,
              new GenericResponseData({ type: 'generate' })
            );
          } else {
            response = new GenericResponse(
              true,
              new GenericResponseData({ type: 'noDiet' })
            );
          }
        }
      } else {
        response = new GenericResponse(false);
      }
      return response;
    });
  }

  getFoodFactPersianName(name: string): string {
    switch (name) {
      case 'protein':
        return 'پروتئین';
      case 'fat':
        return 'چربی';
      case 'carbohydrate':
        return 'کربوهیدرات';
      case 'sugar':
        return 'قند';
      case 'sodium':
        return 'سدیم';
      case 'potassium':
        return 'پتاسیم';
      case 'calcium':
        return 'کلسیم';
      case 'magnesium':
        return 'منیزیم';
      case 'cholesterol':
        return 'کلسترول';
      case 'phosphor':
        return 'فسفر';
      case 'saturatedFat':
        return 'اسید چرب اشباع';
      case 'polyunsaturatedFat':
        return 'اسیدهای چرب چند غیر اشباع';
      case 'transFat':
        return 'اسید چرب ترانس';
      case 'monounsaturatedFat':
        return 'اسید های چرب تک غیر اشباع';
      case 'calorie':
        return 'کالری';
      case 'fiber':
        return 'فیبر';
      case 'iron':
        return 'آهن';
      default:
        return name;
    }
  }

  getFoodFactPersianUnit(name: string): string {
    switch (name) {
      case 'calorie':
        return 'کالری';
      case 'sodium':
      case 'potassium':
      case 'calcium':
      case 'magnesium':
      case 'iron':
      case 'cholesterol':
      case 'phosphor':
        return 'میلی گرم';
      default:
        return 'گرم';
    }
  }

  getMealPersianName(meal: string) {
    switch (meal) {
      case 'breakfast':
        return 'صبحانه';
      case 'snack1':
        return 'میان‌وعده صبح';
      case 'lunch':
        return 'ناهار';
      case 'snack2':
        return 'میان‌وعده عصر';
      case 'dinner':
        return 'شام';
      case 'snack3':
        return 'میان‌وعده شب';
      default:
        return meal;
    }
  }

  getMealRatio(meal: string): number {
    switch (meal) {
      case 'breakfast':
        return 20;
      case 'snack1':
        return 10;
      case 'lunch':
        return 35;
      case 'snack2':
        return 10;
      case 'dinner':
        return 20;
      case 'snack3':
        return 5;
      default:
        return 0;
    }
  }

  private async dietDay(diet: DietModel, day: number): Promise<DietDayModel> {
    const res = await this.prepareDietDayFoods(diet.days[day]);
    return res;
  }

  cheatDay(
    dietId: string,
    day: number,
    isCheat: boolean
  ): Promise<GenericResponse> {
    return this.dietApiService
      .dietCheat(dietId, day, isCheat)
      .then((result) => {
        if (result.isSuccess()) {
          if (isCheat) {
            this.diaryAnalytics.analyticDiaryCheatDaySelected(day);
          } else {
            this.diaryAnalytics.analyticDiaryCheatDayCanceled();
          }
          return this.dietDataService.getDiets().then(async (res) => {
            if (res.diets.length !== 0) {
              res.diets.forEach((diet) => {
                if (diet._id === dietId) {
                  diet.days[day].isCheatDay = isCheat;
                }
              });
              this.planShared.dayStatus = isCheat ? 'cheatDay' : 'diet';
              await this.dietDataService.saveDiets(res.diets);
            }
            return result;
          });
        } else {
          return result;
        }
      });
  }

  findPackage(
    dietId: string,
    meal: string,
    foodName: string
  ): Promise<GenericResponse> {
    return this.dietApiService.findPackage(dietId, meal, foodName);
  }

  findFood(foodName: string): Promise<GenericResponse> {
    return this.dietApiService.findFood(foodName);
  }

  getSelectedPackage(dietId: string, pgId: string): Promise<GenericResponse> {
    return this.dietApiService.getSelectedPackage(dietId, pgId);
  }

  changePackage(
    dietId: string,
    mealPackage: DietSearchMealModel,
    day: string,
    meal: string
  ): Promise<GenericResponse> {
    return this.dietApiService
      .changePackage(dietId, mealPackage._id, day, meal)
      .then((result) => {
        return this.dietDataService.getDiets().then(async (res) => {
          if (res.diets.length !== 0) {
            let selectedMeal: DietMealModel;
            res.diets.forEach((diet) => {
              if (diet._id === dietId) {
                diet.days[parseInt(day) - 1].meals.forEach((m) => {
                  if (m.meal === meal) {
                    m.foods = [];
                    mealPackage.foods.forEach((food, i) => {
                      // const f = new DietFoodModel(
                      //             food.foodId.name,
                      //             food._id,
                      //             food.foodId._id,
                      //             food.foodId,
                      //             mealPackage.amounts[i].amount,
                      //             null
                      //           );
                      const f = new DietFoodModel(
                        null,
                        food._id,
                        food.foodId._id,
                        null,
                        mealPackage.amounts[i].amount,
                        null
                      );
                      // f.foodModel.foodFactModel = this.makeFoodFactsModel(f.foodModel.foodFact);
                      m.foods.push(f);
                    });
                    selectedMeal = m;
                  }
                });
              }
            });
            await this.dietDataService.saveDiets(res.diets);
            this.planShared.selectedMeal = await this.prepareDietMealFoods(
              selectedMeal
            );
          }
          return result;
        });
      });
  }

  changeStatus(
    dietId: string,
    day: string,
    meal: string,
    status: string,
    saveToPlanShared: boolean
  ): Promise<GenericResponse> {
    if (status == 'consumed') {
      this.webengage.foodPackageStatusChanged();
    }
    return this.dietApiService
      .changeStatus(dietId, day, meal, status)
      .then((result) => {
        return this.dietDataService.getDiets().then(async (res) => {
          if (res.diets.length !== 0) {
            res.diets.forEach((diet) => {
              if (diet._id === dietId) {
                diet.days[parseInt(day)].meals.forEach((m) => {
                  if (m.meal === meal) {
                    m.status = status;
                    if (saveToPlanShared) {
                      this.planShared.selectedMeal.status = status;
                    }
                  }
                });
              }
            });
            await this.dietDataService.saveDiets(res.diets);
          }
          return result;
        });
      });
  }

  changeStartDay(dietId: string, startDay: number): Promise<GenericResponse> {
    return this.dietApiService
      .changeStartDay(dietId, startDay)
      .then((result) => {
        if (result.isSuccess()) {
          const startday = result.getData().getStartDay();
          return this.dietDataService.getDiets().then(async (res) => {
            if (res.diets.length !== 0) {
              res.diets.forEach((diet) => {
                if (diet._id === dietId) {
                  diet.startDate = startday;
                }
              });
              await this.dietDataService.saveDiets(res.diets);
            }
            return result;
          });
        } else {
          return result;
        }
      });
  }

  getFoodAmounts(food: DietFoodModel) {
    const ratio = this.calorieCalculator.findFoodRatio(food);
    return food.amount + ' ' + ratio.unitId.name;
  }

  public async prepareDietsFoods(diets: DietModel[]): Promise<DietModel[]> {
    for (let diet of diets) {
      for (let day of diet.days) {
        for (let meal of day.meals) {
          for (let food of meal.foods) {
            let f = await this.foodDataService.getFood(food.food);
            if (f) {
              food.foodModel = f;
            } else {
              await this.dietApiService.getFoods([food.food], true);
              f = await this.foodDataService.getFood(food.food);
              food.foodModel = f;
            }
          }
        }
      }
    }
    return Promise.resolve(diets);
  }
  async prepareDayDietsFoods(dietDay: DietDayModel): Promise<DietDayModel> {
    dietDay.meals.forEach((meals) => {
      meals.foods.forEach(async (food) => {
        let f = await this.foodDataService.getFood(food.food);
        if (f) {
          food.foodModel = f;
        } else {
          await this.dietApiService.getFoods([food.food], true);
          f = await this.foodDataService.getFood(food.food);
          food.foodModel = f;
        }
      });
    });

    return Promise.resolve(dietDay);
  }
  public async prepareDietDayFoods(
    dietDay: DietDayModel
  ): Promise<DietDayModel> {
    let daymealsId = dietDay.meals
      .map((e) => {
        const ids = e.foods
          .map((b) => {
            return b.food;
          })
          .flat();
        return ids;
      })
      .flat();

    let f = await this.foodDataService.getFoods(daymealsId);
    let missingFood = [];

    f = f.map((e, i) => {
      if (!e) {
        missingFood.push(daymealsId[i]);

        return daymealsId[i];
      } else {
        return e;
      }
    });

    if (missingFood.length > 0) {
      await this.dietApiService.getFoods(missingFood, true);
      missingFood = await this.foodDataService.getFoods(missingFood);

      f = await f.map((v, i) => {
        if (typeof v === 'string') {
          let data = missingFood.find((d) => {
            return d._id == f[i];
          });

          return data;
        } else {
          return f[i];
        }
      });
    }

    await dietDay.meals.map((e) => {
      e.foods.map((b) => {
        let data = f.find((d, i) => {
          if (!d) {
            return b.food == daymealsId[i];
          }
          return b.food == d?._id;
        });
        b.foodModel = data;
      });
    });

    return Promise.resolve(dietDay);
  }

  public async prepareDietDayFoodLogs(
    dietDayFoodLogs: DietDayFoodLogsModel
  ): Promise<DietDayFoodLogsModel> {
    for (let foodLog of dietDayFoodLogs.foodLogs) {
      if (!foodLog.calorie && !foodLog.calorie) {
        let food = await this.foodDataService.getFood(foodLog.food);
        if (food) {
          foodLog.foodModel = food;
        } else {
          await this.dietApiService.getFoods([foodLog.food], true);
          food = await this.foodDataService.getFood(foodLog.food);
          foodLog.foodModel = food;
        }
      }
    }
    return Promise.resolve(dietDayFoodLogs);
  }

  public async prepareDietMealFoods(
    dietMeal: DietMealModel
  ): Promise<DietMealModel> {
    for (let f of dietMeal.foods) {
      let food = await this.foodDataService.getFood(f.food);
      if (food) {
        f.foodModel = food;
      } else {
        await this.dietApiService.getFoods([f.food], true);
        food = await this.foodDataService.getFood(f.food);
        f.foodModel = food;
      }
    }
    return Promise.resolve(dietMeal);
  }

  makeFoodFactsModel(f: FoodFacts): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }

  async getUserStableCalorie(date: Date): Promise<number> {
    const user = await this.userDataService.getUser();
    let userWeight = 0;

    const weightlogResponse = await this.weightLogService.getSelectedDayWeight(
      date
    );
    if (weightlogResponse.isSuccess()) {
      userWeight = weightlogResponse.getData().getWeightLog().weight;
    } else {
      userWeight = user.weight;
    }
    let bmr =
      10 * userWeight +
      6.25 * user.height -
      5 * this.calculateAge(user.birthDate);
    bmr = user.sex === 'female' ? bmr - 166 : bmr + 5;
    return Math.floor(1.37 * bmr);
  }

  calculateAge(birthDate: number): number {
    const today = new Date();
    const birthdate = new Date(birthDate);
    let age = today.getFullYear() - birthdate.getFullYear();
    const m = today.getMonth() - birthdate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
      age--;
    }
    return age;
  }
  addTohistory(item: FoodModel) {
    const recent = localStorage.getItem('recentPersnoalSearch');
    if (recent && item && item.name) {
      const recents = JSON.parse(recent);
      const names = recents.map((el) => el.name);
      if (!names.includes(item.name)) {
        if (recents.length < 10) {
          localStorage.setItem(
            'recentPersnoalSearch',
            `${JSON.stringify([...recents, item])}`
          );
        } else {
          recents.shift();
          localStorage.setItem(
            'recentPersnoalSearch',
            `${JSON.stringify([...recents, item])}`
          );
        }
      }
    } else {
      localStorage.setItem('recentPersnoalSearch', `${JSON.stringify([item])}`);
    }
  }
  getHistory() {
    return JSON.parse(localStorage.getItem('recentPersnoalSearch'));
  }
  removeHistory(f: FoodModel) {
    const recent = localStorage.getItem('recentPersnoalSearch');
    if (recent) {
      const recents = JSON.parse(recent);
      const newRecents = recents.filter((i) => i._id !== f._id);

      localStorage.setItem(
        'recentPersnoalSearch',
        `${JSON.stringify([...newRecents])}`
      );
    }
  }
}
